<template>
  <div>
    <form @submit.prevent="buscarPedido">
      <div class="row m-1 mb-3 testesSPi">
        <div class="col-8">
          <fccInput type="number" extraClasses="inputLabel" v-model="numeroPedido" required
            >Número Pedido</fccInput
          >
        </div>
        <div class="col-4">
          <fccButton tipo="submit">Buscar</fccButton>
          <fccButton tipo="button" class="ml-1" @click="limparPedido" v-if="insc != null"
            >Limpar</fccButton
          >
        </div>
      </div>
    </form>
    <template v-if="mostraPedido">
      <template v-if="insc.listalaudoinvalido.length > 0">
        <div class="shadow card p-3 pt-4">
          <h5 v-for="(laudoinvalido, index) in insc.listalaudoinvalido" :key="index">
            {{ laudoinvalido.descricao }}
          </h5>
        </div>
      </template>
      <template v-if="insc.listatipodeficiencia.length > 0">
        <div class="shadow card p-3 pt-4 mt-2">
          <div v-for="(tipodeficiencia, index) in insc.listatipodeficiencia" :key="index">
            <strong>{{ tipodeficiencia.descricao }}</strong>
          </div>
        </div>
      </template>
      <template v-if="insc.listavagasreservadas.length > 0">
        <div class="shadow card p-3 pt-4 mt-2">
          <strong>VAGAS RESERVADAS</strong>
          <div v-for="(vagasreservadas, index) in insc.listavagasreservadas" :key="index">
            {{ vagasreservadas.descricao }}
          </div>
        </div>
      </template>
      <template v-if="insc.listaprovaespecial.length > 0">
        <div class="shadow card p-3 pt-4 mt-2">
          <strong>PROVAS ESPECÍFICAS</strong>
          <div v-for="(provaespecial, index) in insc.listaprovaespecial" :key="index">
            {{ provaespecial.descricao }}
          </div>
        </div>
      </template>
      <template v-if="insc.listasolicitacaoespecial.length > 0">
        <div class="shadow card p-3 pt-4 mt-2">
          <strong>CONDIÇÃO ESPECÍFICA</strong>
          <div v-for="(solicitacaoespecial, index) in insc.listasolicitacaoespecial" :key="index">
            {{ solicitacaoespecial.descricao }}
          </div>
        </div>
      </template>
      <template v-if="insc.listasalareservada.length > 0">
        <div class="shadow card p-3 pt-4 mt-2">
          <div v-for="(vagasreservadas, index) in insc.listasalareservada" :key="index">
            <strong> {{ vagasreservadas.descricao }}</strong>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="q-mt-sm q-mb-sm">
        <div class="bg-grey-4 q-pa-sm">
          <strong> SEM RESULTADOS</strong>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      numeroPedido: '',
      mostraPedido: false,
      insc: null
    }
  },
  methods: {
    limparPedido() {
      this.mostraPedido = false
      this.insc = null
      this.numeroPedido = ''
    },
    buscarPedido() {
      this.mostraPedido = false
      this.insc = null
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlPublicacao +
            'Publicacao/VagasReservadasPorPedido?spi=' +
            this.controlePage.spi +
            '&numPedido=' +
            this.numeroPedido,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (
            response.data.listalaudoinvalido.length > 0 ||
            response.data.listaprovaespecial.length > 0 ||
            response.data.listasolicitacaoespecial.length > 0 ||
            response.data.listatipodeficiencia.length > 0 ||
            response.data.listavagasreservadas.length > 0
          ) {
            this.mostraPedido = true
            this.insc = response.data
          } else {
            this.callAlert('Nenhum pedido encontrado', '', 'error', 'error')
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted() {
    this.limparPedido()
  },
  props: {
    controlePage: Object
  }
}
</script>
